import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { API } from '../../API';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import { Box, Button, ListItemIcon } from '@mui/material';
import './notification.css';
import UpcomingIcon from '@mui/icons-material/Upcoming';
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  iconStyle: {
    marginRight: "10px",
    color: "#0f7adf"
  }
});

export default function ListNotification({ notifications, setNotifications, handleRedirect, setUnreadNotificationsNumber, role }) {
  const styles = useStyles();

  const handleReadNoti = (noti) => {
    if (noti.is_read) {
      handleRedirect(noti);
      return;
    }

    API.readNotification(noti._id)
      .then((res) => {
        const newNotis = notifications.map(
          notification => notification._id === noti._id ? { ...notification, is_read: true } : notification
        );
        setNotifications(newNotis);
        setUnreadNotificationsNumber((prevData) => prevData - 1)
        handleRedirect(noti);
      })
      .catch((error) => {
        console.log(`error`, error);
      });
  };

  const handleReadAllNotifications = () => {
    const unreadNotifications = notifications.filter((noti) => !noti.is_read)
    if (unreadNotifications.length === 0) return

    const ids = unreadNotifications.map((noti) => noti._id)
    API.readAllNotification({
      notificationIDs: ids
    }).then((rs) => {
      const newNotis = notifications.map(notification => {
        notification.is_read = true;
        return notification;
      });
      setNotifications(newNotis);
      setUnreadNotificationsNumber(0)
    }).catch((error) => {
      console.log(`error - read all notifications: `, error);
    });
  }

  const getIconForNotification = (notiType) => {
    let icon = <></>

    switch (notiType) {
      default:
        icon = <UpcomingIcon className={styles.iconStyle}/>
        break;
    }

    return icon
  }

  return (
    <>
      <List className='list-noti' sx={{ bgcolor: '#FAF6F6', overflowY: "scroll", paddingTop: "0px" }}>
        {
          notifications.length === 0 &&
          <Typography variant="h6" className="ml-3 title">You don't have any notifications</Typography>
        }
        {
          notifications.map((notification, index) => (
            <React.Fragment key={index}>
              <ListItem
                alignItems="center"
                sx={{
                  "&:hover": { backgroundColor: '#F2F3F5', cursor: "pointer" }
                }}
                onClick={() => handleReadNoti(notification)}
                className="list-item"
              >
                {
                  role === "teacher" && (
                    <ListItemAvatar className="list-item-avatar">
                      <Avatar src={notification.photo  || "/static/images/avatar/2.jpg"} className="noti-avatar" />
                    </ListItemAvatar>
                  )
                  
                }
                {
                  (role === "customer" || role ==="personnel") && getIconForNotification(notification.type) && (
                    <ListItemIcon className="list-item-icon noti-icon">
                      {getIconForNotification(notification.type)}
                    </ListItemIcon>
                  )
                }
                <ListItemText
                  sx={{fontSize: "14px"}}
                  secondary={
                    <React.Fragment>
                      <Typography sx={{ fontSize: "14px" }} className={"noti-content " + (!notification.is_read && "unread")}>
                        {notification?.content || ""}
                      </Typography>
                    </React.Fragment>
                  }
                />
                {
                  !notification.is_read && (
                    <ListItemIcon className="list-item-icon">
                      <Brightness1Icon fontSize='small' className="circle-icon"/>
                    </ListItemIcon>
                  )
                }
              </ListItem>
              {index < notifications.length - 1 && <Divider className="divider-item ml-0" variant="inset" component="li" />}
            </React.Fragment>
          ))
        }
      </List>
      {
        notifications.filter((noti) => !noti.is_read).length > 0 && (
          <Box>
            <Button
              variant="contained"
              sx={{
                borderRadius: 0,
              }}
              className="w-100 read-all-btn"
              onClick={handleReadAllNotifications}
            >
              Mark all as read
            </Button>
        </Box>
        )
      }
    </>
  );
}
